export default "__VITE_ASSET__CDdiKWNe__"